import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { useState, useEffect } from "react";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const NewWeeklyRevenueChart = ({ weeklyRevenueData }) => {
  const labels = weeklyRevenueData.map((entry) => entry.week);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const productTypes = [
  //   "hydroponic masterclass",
  //   "physical site inspection",
  //   "site inspection kit",
  //   "practical training",
  //   "aif project report",
  // ];

  const datasets = [
    {
      label: "physical site inspection",
      data: weeklyRevenueData.map((week) => {
        const product = week.products.find(
          (p) => p.name === "physical site inspection"
        );
        return product ? product.rawAmount : 0;
      }),
      countData: weeklyRevenueData.map((week) => {
        const product = week.products.find(
          (p) => p.name === "physical site inspection"
        );
        return product?.count || 0;
      }),
      backgroundColor: "#D4786F",
    },
    {
      label: "AIF Project Report",
      data: weeklyRevenueData.map((week) => {
        const product = week.products.find(
          (p) => p.name === "aif project report"
        );
        return product ? product.rawAmount : 0;
      }),
      countData: weeklyRevenueData.map((week) => {
        const product = week.products.find(
          (p) => p.name === "aif project report"
        );
        return product?.count || 0;
      }),
      backgroundColor: "#CFD486",
    },
    {
      label: "Farm Training",
      data: weeklyRevenueData.map((week) => {
        const product = week.products.find(
          (p) => p.name === "practical training"
        );
        return product ? product.rawAmount : 0;
      }),
      countData: weeklyRevenueData.map((week) => {
        const product = week.products.find(
          (p) => p.name === "practical training"
        );
        return product?.count || 0;
      }),
      backgroundColor: "#D4A06F",
    },
    {
      label: "All Other Products",
      data: weeklyRevenueData.map((week) => {
        const product = week.products.find((p) => p.name === "allother");
        return product ? product.rawAmount : 0;
      }),
      countData: weeklyRevenueData.map((week) => {
        const product = week.products.find((p) => p.name === "allother");
        return product?.count || 0;
      }),
      backgroundColor: "#D46FD0",
    },
    {
      label: "Hydroponic Masterclass",
      data: weeklyRevenueData.map((week) => {
        const product = week.products.find(
          (p) => p.name === "hydroponic masterclass"
        );
        return product ? product.rawAmount : 0;
      }),
      countData: weeklyRevenueData.map((week) => {
        const product = week.products.find(
          (p) => p.name === "hydroponic masterclass"
        );
        return product?.count || 0;
      }),
      backgroundColor: "#6F95D4",
    },

    {
      label: "Site Inspection Kit",
      data: weeklyRevenueData.map((week) => {
        const product = week.products.find(
          (p) => p.name === "site inspection kit"
        );
        return product ? product.rawAmount : 0;
      }),
      countData: weeklyRevenueData.map((week) => {
        const product = week.products.find(
          (p) => p.name === "site inspection kit"
        );
        return product?.count || 0;
      }),
      backgroundColor: "#FFA500",
    },
  ];

  const chartData = {
    labels,
    datasets,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
      },
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || "";
            const revenue = context.formattedValue;
            const count = context.dataset.countData?.[context.dataIndex] || 0;
            return `${label}: ₹${revenue} (Count: ${count})`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 10000,
        },
        title: {
          display: true,
          text: "Revenue (₹)",
        },
      },
      x: {
        title: {
          display: true,
          text: "Weeks",
        },
      },
    },
  };

  return (
    <div className="card p-4">
      <h3 className="card-title">Weekly Revenue Overview</h3>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default NewWeeklyRevenueChart;
